type UseIsRestrictedUser = () => boolean;
export const useIsRestrictedUser: UseIsRestrictedUser = () => false;
